import * as React from "react"
import { SVGProps } from "react"
const OnlineOrderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={32}
    data-name="Component 6438 \u2013 15"
    {...props}
  >
    <g fill="none" data-name="Path 5804">
      <path d="M0 25.237V8.328h30v16.909c0 3.735-2.686 6.764-6 6.764H6C2.686 32 0 28.972 0 25.237Z" />
      <path
        fill={props?.fill ? props.fill : "#fff"}
        d="M24 30c2.206 0 4-2.137 4-4.763V10.328H2v14.909C2 27.863 3.794 30 6 30h18m0 2H6c-3.314 0-6-3.028-6-6.763V8.328h30v16.909C30 28.972 27.314 32 24 32Z"
      />
    </g>
    <g fill="none" fillRule="evenodd" data-name="Path 5805">
      <path d="M6 0h18c3.314 0 6 3.158 6 7.052v3.526H0C0 3.158 2.686 0 6 0Z" />
      <path
        fill={props?.fill ? props.fill : "#fff"}
        d="M6 2c-1.047 0-1.882.515-2.552 1.575-.537.85-1.158 2.37-1.371 5.003H28V7.052c0-1.41-.455-2.72-1.28-3.69C25.971 2.484 25.006 2 24 2H6m0-2h18c3.314 0 6 3.158 6 7.052v3.526H0C0 3.158 2.686 0 6 0Z"
      />
    </g>
    <circle
      cx={1}
      cy={1}
      r={1}
      fill={props?.fill ? props.fill : "#fff"}
      data-name="Ellipse 796"
      transform="translate(23 4)"
    />
    <circle
      cx={1}
      cy={1}
      r={1}
      fill={props?.fill ? props.fill : "#fff"}
      data-name="Ellipse 797"
      transform="translate(19 4)"
    />
    <g
      fill={props?.fill ? props.fill : "#fff"}
      stroke={props?.fill ? props.fill : "#fff"}
      strokeWidth={2}
      data-name="Rectangle 4580"
      transform="translate(7 15)"
    >
      <rect width={8} height={2} stroke="none" rx={1} />
      <rect width={6} x={1} y={1} fill="none" />
    </g>
    <g
      fill={props?.fill ? props.fill : "#fff"}
      stroke={props?.fill ? props.fill : "#fff"}
      strokeWidth={2}
      data-name="Rectangle 4581"
      transform="translate(7 23)"
    >
      <rect width={15} height={2} stroke="none" rx={1} />
      <rect width={13} x={1} y={1} fill="none" />
    </g>
  </svg>
)
export default OnlineOrderIcon